import React from 'react';
import { Check } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { STEP_STATE } from './constants';
import { getIconBorderColor } from './helpers';
import { StepIconStyled } from './styled';
export function StepIcon({ iconState, stepNumber, isRightToLeft }) {
    const borderColor = getIconBorderColor(iconState);
    const content = iconState !== STEP_STATE.passed ? (stepNumber) : (React.createElement(SVGIcon, { type: Check, size: ICON_SIZE.s }));
    return (React.createElement(StepIconStyled, { isCurrentStep: iconState === STEP_STATE.current, borderColor: borderColor, isRightToLeft: isRightToLeft, alignItems: "center", justifyContent: "center" }, content));
}
